import { IConsultarDare } from 'store/modules/api/dare/consultarDare/types';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

export interface IRequestAtualizarDare {
	numeroDare?: string;
	rgAtendimento: string;
	isento: boolean;
	entregaCorreio: boolean;
	// ENVIAR O STATUS PARA GRAVAR NO CADASTRORG.DARE.STATUS
	dare?: IConsultarDare;
}

export function atualizarDareRequest(
	token: string,
	payload: IRequestAtualizarDare,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_DARE_REQUEST,
		token,
		payload,
	};
}
export function atualizarDareSuccess(
	payload: IConsultarDare,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_DARE_SUCCESS,
		payload,
	};
}
export function atualizarDareFailure(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_DARE_FAILURE,
		payload: null,
	};
}
export function atualizarDareClear(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_DARE_CLEAR,
		payload: null,
	};
}
